import React from 'react';

const DueIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#FFF8E8" />
    <path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z" stroke="#F8C203" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 8.9397V12.5397L14.4 13.7397" stroke="#F8C203" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default DueIcon;
